import React, { useMemo } from 'react';
import { Selector } from '@leverege/ui-elements';
import Unit from '@leverege/unit';
import StringUtil from '@leverege/string-util';
import { ns } from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.UnitSelector');
export default function UnitSelector(props) {
  const {
    attribute,
    unitType,
    value = attribute?.baseUnit,
    eventData,
    onChange,
    baseUnits = false,
    includeDefault = false,
    variant,
    ...rest
  } = props;
  const unitTypes = useMemo(() => {
    if (!unitType) {
      return null;
    }
    if (baseUnits) {
      return Unit.getBaseUnitTypes(unitType);
    }
    const types = Unit.getUnitsOfType(unitType);
    if (!types) {
      return null;
    }
    const ret = types.map(unit => {
      return {
        value: unit.symbol,
        name: unit.symbol === attribute?.baseUnit ? `${StringUtil.capitalize(unit.name)} (Default)` : StringUtil.capitalize(unit.name)
      };
    });
    if (includeDefault) ret.unshift({
      value: null,
      name: t('default')
    });
    return ret;
  }, [unitType, baseUnits, includeDefault]);
  if (!unitTypes) {
    return null;
  }
  return /*#__PURE__*/_jsx(Selector, {
    ...rest,
    title: renderer,
    variant: variant,
    toggleVariant: variant,
    value: value,
    values: unitTypes,
    onChange: onChange,
    eventData: eventData
  });
}
function renderer(item) {
  if (!item) {
    return 'Select Unit';
  }
  return item?.value == null ? item.name : item.value;
}